
import { createSlice } from '@reduxjs/toolkit';

export const portInSlice = createSlice({
  name: 'portin',
  initialState: {
    portInValues: [],
    pages: [],
    basicValues: {},
    contactNumbers: [],
    networkTypes: {},
    mainNumbers: {},
    assignNumbers: [],
    replacaNumber: [],
  },
  reducers: {
    setPortInValues: (state, action) => {
      state.portInValues = action.payload;
    },
    setpages: (state, action) => {
      state.pages = action.payload;
    },
    setBasicValues: (state, action) => {
      state.basicValues = action.payload;
    },
    setContactNumbers: (state, action) => {
      state.contactNumbers = action.payload;
    },
    setMainNumbers: (state, action) => {
      state.mainNumbers = action.payload;
    },
    setNetworkTypes: (state, action) => {
      state.networkTypes = action.payload;
    },
    setAssignNumbers: (state, action) => {
      state.assignNumbers = action.payload;
    },
    setReplaceNumber: (state, action) => {
      state.replacaNumber = action.payload;
    },
  }
});

export const {
  setPortInValues,
  setpages,
  setBasicValues,
  setContactNumbers,
  setNetworkTypes,
  setMainNumbers,
  setAssignNumbers,
  setReplaceNumber,
} = portInSlice.actions

export default portInSlice.reducer;
